import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from "echarts";

import Vant from 'vant';
import 'vant/lib/index.css';
import Common from "@/utils/common";

Vue.use(Vant);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.commons=Common


router.beforeEach((to, from, next)=>{
  var session =localStorage.getItem("Authorization");
  if (!session && to.name!=='login' ){
    next({name:'login'})
  }else if(session && to.name==='login'){
    next({name:'home'})
  }else {
    next();
  }

})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
